// Interest rate shown in the List View. A rate Capital Markets entered by hand
// (flagged in loanEconomics.pricingOverrideFlags.interestRate) must win over
// the buy-down option selection (currentSelectedInterestRate), which holds an
// auto-computed rate and would otherwise show a different number.
export const resolveListInterestRate = (loanData: any) => {
  const loanEconomics = loanData?.loanEconomics;
  const isManualRate = Boolean(loanEconomics?.pricingOverrideFlags?.interestRate);
  const manualRate = isManualRate
    ? loanEconomics?.interestRate || loanEconomics?.lastEnteredInterestRate
    : null;

  return (
    (manualRate ||
      loanData?.currentSelectedInterestRate?.interestRate ||
      loanEconomics?.interestRate ||
      loanEconomics?.lastEnteredInterestRate ||
      loanEconomics?.originalInterestRate) ??
    null
  );
};
